<form
  class="search-query"
  (submit)="submit()"
>
  @if (newLayout && !mediumScreen) {
    <div class="search-query__new-layout row "> <!--new layout-->
      @if (!useNewLayout) {
        <div class="search-query__input">
          @if (!hideIcon) {
            <div class="search-icon-container">
              <span class="search-icon">
                <i class="icon-search"></i>
              </span>
            </div>
          }

          @if (queryContainer.selectedQueryMenu?.query_type === 'field_search') {
            <app-search-query-field-search
              [queryPlaceholder]="queryPlaceholder"
              [searchContainer]="searchContainer"
            ></app-search-query-field-search>
          }
          @else if (queryContainer.selectedQueryMenu?.query_type === 'advanced') {
            <app-search-query-extended-search
              [searchContainer]="searchContainer"
            />
          }
          @else {
            <input
              type="text"
              id="searchQueryNew"
              autocomplete="off"
              [ngClass]="{'errorInputFrame': searchCount === 0 && queryContainer.query && queryContainer.query.length > 0 }"
              [(ngModel)]="query"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="queryChanged()"
              [placeholder]="queryPlaceholder"
            >

            <a
              class="clear-input-field"
              (click)="clearSearch()"
            >
              <mat-icon>
                close
              </mat-icon>
            </a>
          }
        </div>
      }
      @else {
        @if (queryContainer.selectedQueryMenu?.query_type === 'advanced') {
          <app-search-query-extended-search
            [searchContainer]="searchContainer"
          />
        }
        @else {
          <div class="search-query__input">
            @if (!hideIcon) {
              <div class="search-icon-container">
                <span class="search-icon">
                  <i class="icon-search"></i>
                </span>
              </div>
            }

            @if (queryContainer.selectedQueryMenu?.query_type === 'field_search') {
              <app-search-query-field-search
                [queryPlaceholder]="queryPlaceholder"
                [searchContainer]="searchContainer"
              ></app-search-query-field-search>
            }
            @else {
              <input
                type="text"
                id="searchQueryNew"
                autocomplete="off"
                [ngClass]="{'errorInputFrame': searchCount === 0 && queryContainer.query && queryContainer.query.length > 0 }"
                [(ngModel)]="query"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="queryChanged()"
                [placeholder]="queryPlaceholder"
              >

              <a
                class="clear-input-field"
                (click)="clearSearch()"
              >
                <mat-icon>
                  close
                </mat-icon>
              </a>
            }
          </div>
        }
      }

      @if (!pathAsFilter && useNewLayout) {
        <button
          mat-button
          type="button"
          (click)="toggleMenu()"
          [matMenuTriggerFor]="newMenu"
        >
          <div>
            <span>
              {{ !!searchContainer.searchCategory ? searchContainer.searchCategory.category.name : (queryContainer.selectedQueryMenu?.description | translate) }}
            </span>

            <span class="search-query__search-count">
              &nbsp;({{searchCount}})
            </span>
          </div>

          @if (pathViewMenus.menus.length > 0) {
            <mat-icon matSuffix>
              {{ showMenu ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          }
        </button>
      }
      @else if (!pathAsFilter && !useNewLayout) {
        <div class="search-query-inline-menu search-input-menu-trigger">
          <button
            type="button"
            [matMenuTriggerFor]="newMenu"
            (click)="toggleMenu()"
            [ngClass]="{'active': showMenu, 'notButton': pathViewMenus.menus.length < 1}"
            class="search-query-inline-menu__button"
          >
            <span class="vertical-line"></span>

            <span class="search-query-inline-menu__button-content">
              <span class="flex-grow search-query-inline-menu__button-content-text">
                <span>
                  {{ !!searchContainer.searchCategory ? searchContainer.searchCategory.category.name : (queryContainer.selectedQueryMenu?.description | translate) }}
                </span>

                <span>
                  ({{searchCount}})
                </span>
              </span>

              @if (pathViewMenus.menus.length) {
                <mat-icon class="search-query-inline-menu__button-icon">
                  {{showMenu ? 'expand_less' : 'expand_more'}}
                </mat-icon>
              }
            </span>
          </button>
        </div>
      }

      @if (pathAsFilter) {
        <app-search-query-path-menu
          [showPathMenu]="showPathMenu"
          [searchContainer]="searchContainer"
          (menuPathSet)="onMenuPathSet($event)"
        ></app-search-query-path-menu>
      }
    </div>
  }
  @else if (!newLayout || mediumScreen) {
    <div
      class="search-query__old-layout"
      [ngClass]="{'noBorder': noBorder}"
    > <!--old layout: used in selector and on small screens-->
      <div class="search-query__input">
        <div
          class="search-query-pop-up-menu-button"
          [ngClass]="{'notButton': pathViewMenus.menus.length < 1}"
        >
          <button
            class="search-query-pop-up-menu-button__content"
            (click)="toggleMenu()"
            type="button"
            [matMenuTriggerFor]="newMenu"
          >
            <span
              class="search-icon"
              [class.text-blue]="showMenu"
              [ngClass]="{'text-blue-hover': pathViewMenus.menus.length > 0}"
            >
              <mat-icon>
                search
              </mat-icon>

              @if (pathViewMenus.menus.length) {
                <mat-icon class="search-icon-arrow">
                  arrow_drop_down
                </mat-icon>
              }
            </span>
          </button>
        </div>

        @if (queryContainer.selectedQueryMenu?.query_type !== 'advanced') {
          <input
            type="text"
            id="searchQueryOld"
            [ngClass]="{'errorInputFrame': searchCount === 0 && queryContainer.query && queryContainer.query.length > 0 }"
            [(ngModel)]="query"
            (change)="queryChanged()"
            autocomplete="off"
            [ngModelOptions]="{standalone: true}"
            placeholder="{{queryPlaceholder}} ({{searchCount}} {{'TRANS__HEADER__RESULTS' | translate}})"
          >

          @if (queryContainer.query) {
            <a
              class="clear-input-field"
              (click)="clearSearch()"
            >
              <mat-icon>
                close
              </mat-icon>
            </a>
          }
        }
      </div>
    </div>
  }

  <mat-menu
    #newMenu="matMenu"
    yPosition="below"
    (closed)="showMenu = false;"
    class="removePaddingInMatMenu search-input-menu-drop-down"
  >
    @for (menu of pathViewMenus.menus; track $index) {
      <div>
        @if (menu.menus) {
          <button
            mat-menu-item
            type="button"
            (click)="togglePathViewMenus(menu); $event.stopPropagation();"
            class="menu-button-with-icons"
          >
            <span class="bold flex-grow">
              {{ menu.description | translate }}
            </span>

            <mat-icon>
              {{menu.query_type === selectedPathViewMenu ? 'expand_less' : 'expand_more'}}
            </mat-icon>
          </button>

          @if (menu.query_type === selectedPathViewMenu) {
            <div>
              @if (menu.query_type === 'search_category') {
                <div class="">
                  @for (search of storedSearchCategoriesForUser; track $index) {
                    <button
                      mat-menu-item
                      type="button"
                      [ngClass]="{'active': search.category.name === searchContainer?.searchCategory?.category?.name}"
                      class="menu-button-with-icons"
                    >
                      <a
                        (click)="useSearchCategory(search, true)"
                        class="flex-grow sub-menu-item"
                      >
                        <mat-icon class="search-input-menu-drop-down__icon">
                          find_in_page
                        </mat-icon>

                        <span>
                          {{ search.category.name }}
                        </span>
                      </a>

                      <a
                        class="sub-menu-item"
                        (click)="deleteSearchCategory(search)"
                      >
                        <mat-icon
                          class="search-input-menu-drop-down__icon"
                          color="warn"
                        >
                          delete_outline
                        </mat-icon>
                      </a>

                      <a
                        class="sub-menu-item"
                        (click)="editOrCreateSearchCategory(search)"
                      >
                        <mat-icon class="search-input-menu-drop-down__icon">
                          edit
                        </mat-icon>
                      </a>
                    </button>
                  }
                </div>
              }

              @if (menu.menus) {
                <div>
                  @for (subMenuItem of menu.menus; track $index) {
                    <button
                      mat-menu-item
                      (click)="selectQueryMenu(subMenuItem)"
                      [ngClass]="{'active': subMenuItem.selected}"
                    >
                      @if (subMenuItem.icon_class) {
                        <i [class]="subMenuItem.icon_class"></i>
                      }

                      @if (subMenuItem.icon) {
                        <mat-icon class="search-input-menu-drop-down__icon">
                          {{ subMenuItem.icon }}
                        </mat-icon>
                      }

                      <span>
                        {{ subMenuItem.description | translate }}
                      </span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        }
        @else {
          <button
            mat-menu-item
            (click)="selectQueryMenu(menu)"
            [ngClass]="{'active': menu.selected}"
          >
            <span>
              {{ menu.description | translate }}
            </span>
          </button>
        }
      </div>
    }
  </mat-menu>
</form>
